import React, { PureComponent } from "react";
import { connect } from "react-redux";
import images from "assets/images";
import get from "lodash/get";

import { PlatformSelector, SEO } from "components";

import { getPage } from "actions/page/page.functions";

class Biond extends PureComponent {
  state = {
    platform: undefined
  };

  componentDidMount() {
    const { dispatch } = this.props;

    let slug = "biond";
    dispatch(getPage(slug));
  }

  handleUpdatePlatform = event => {
    const { platform } =
      event.currentTarget.dataset || event.srcElement.dataset;

    this.setState({ platform });
  };

  render() {
    const { platform } = this.state;
    const { singlePage } = this.props;

    const platformSelectorProps = {
      platform,
      updatePlatformCallback: this.handleUpdatePlatform
    };

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    return (
      <main className="view-biond">
        <SEO {...seoProps} />
        <section className="view-biond__meet">
          <div className="view-biond__meet__layout">
            <div className="view-biond__meet__layout__visual">
              <img alt="Meet Biond." src={images.illustrationAboutHeader} />
            </div>
            <div className="view-biond__meet__layout__content">
              <h1 className="u-type--beta u-type--primary u-spc-bottom--xlrg">
                Meet Biond.
              </h1>
              <p className="u-type--epsilon u-type--o70 u-spc-bottom--lrg">
                Mobile Communications App that combines voice and video calls,
                single chat and group messaging through Internet connection
              </p>
              <p className="u-type--zeta u-type--o50">
                Make phone calls and exchange messages without paying for any
                voice or SMS plans
              </p>
            </div>
          </div>
        </section>
        <section className="view-biond__features">
          <div className="view-biond__features__layout--alt">
            <div className="view-biond__features__layout--alt__visual">
              <img alt="Messaging" src={images.illustrationMessaging} />
            </div>
            <div className="view-biond__features__layout--alt__content">
              <h3 className="u-type--gamma u-type--primary u-spc-bottom--lrg">
                Messaging
              </h3>
              <p className="u-type--zeta u-type--o70">
                Fast and free chat in real-time or simply send SMS
              </p>
            </div>
          </div>

          <div className="view-biond__features__layout">
            <div className="view-biond__features__layout__visual">
              <img alt="Voice" src={images.illustrationPhoneMark} />
            </div>
            <div className="view-biond__features__layout__content">
              <h3 className="u-type--gamma u-type--primary u-spc-bottom--lrg">
                Voice
              </h3>
              <p className="u-type--zeta u-type--o70">
                Call your friends using Internet connection without charges or
                Biond Out and reach them over mobile or landline at low cost
                with crystal clear voice quality
              </p>
            </div>
          </div>

          <div className="view-biond__features__layout--alt view-biond__features__layout--alt--video">
            <div className="view-biond__features__layout--alt__visual">
              <img alt="Video" src={images.illustrationPhoneWoman} />
            </div>
            <div className="view-biond__features__layout--alt__content">
              <h3 className="u-type--gamma u-type--primary u-spc-bottom--lrg">
                Video
              </h3>
              <p className="u-type--zeta u-type--o70">
                One-to-One conversations with your friends and family on long
                distance with no interruptions
              </p>
            </div>
          </div>

          <div className="view-biond__features__layout view-biond__features__layout--sharing">
            <div className="view-biond__features__layout__visual">
              <img alt="Sharing" src={images.illustrationFolder} />
            </div>
            <div className="view-biond__features__layout__content">
              <h3 className="u-type--gamma u-type--primary u-spc-bottom--lrg">
                Sharing
              </h3>
              <p className="u-type--zeta u-type--o70">
                Share images, videos, voice recording and all document types
                with file sharing in a fraction of a second.
              </p>
            </div>
          </div>
        </section>

        <section className="section section--primary section--dark view-biond__security">
          <div className="wrapper">
            <div className="view-biond__security__layout">
              <div className="view-biond__security__layout__visual">
                <img alt="Security" src={images.illustrationHomePrivacy} />
              </div>
              <div className="view-biond__security__layout__content">
                <h3 className="u-type--gamma u-type--negative u-spc-bottom--xlrg">
                  Security
                </h3>
                <p className="u-type--zeta u-type--negative u-type--o50 u-spc-bottom--lrg">
                  Encryption mechanisms ensure that your conversation remains
                  private. Compliance with industry standard security measures
                  makes Biond safe for use.
                </p>
                <div className="microfeatures">
                  <span className="microfeatures__item microfeatures__item--negative">
                    <svg
                      width="12"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <g opacity=".5" stroke="#FFF">
                          <path d="M3.5 5.1V3a2.5 2.5 0 1 1 5 0v2.1" />
                          <circle cx="6" cy="10" r="5.5" />
                        </g>
                        <circle stroke="#20B8B1" cx="6" cy="10" r="2" />
                      </g>
                    </svg>
                    Encryption
                  </span>
                  <span className="microfeatures__item microfeatures__item--negative">
                    <svg
                      width="15"
                      height="16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        stroke="#FFF"
                        fill="none"
                        fillRule="evenodd"
                        opacity=".5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M7.5 1C6.1 2.4 3.767 3.8.5 4.267c0 0 0 7.933 7 10.733 7-2.8 7-10.733 7-10.733C11.233 3.8 8.9 2.4 7.5 1zM7.5 15V1M1.344 8.5h12.312" />
                      </g>
                    </svg>
                    Firewall
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section section--primary view-biond__store">
          <div className="view-biond__store__layout">
            <div className="view-biond__store__layout__visual">
              <img alt="Biond Store" src={images.illustrationBiondStore} />
            </div>
            <div className="view-biond__store__layout__content">
              <h3 className="u-type--gamma u-spc-bottom--lrg">Biond Store</h3>
              <p className="u-type--zeta u-type--o70">
                Download more. Share more. Play more. Spice up your chat with
                stickers and animations. Download more stickers, audio effects,
                and animations from our new Biond Store. Buy Biond Credit and
                call landlines and mobile numbers worldwide without extra fees
                and charges.
              </p>
            </div>
          </div>
        </section>
        <section className="download">
          <div className="wrapper">
            <div className="download__layout">
              <div className="download__layout__content u-type--center">
                <h3 className="download__title u-type--gamma u-type--primary u-spc-bottom--lrg">
                  Get your Biond App now!
                </h3>
                <p className="u-type--zeta u-type--o70 u-spc-bottom--lrg">
                  Biond App comes in all shapes and sizes. <br />
                  Download Biond App for iOS and Android. Coming soon: macOS,
                  Windows 10 or Linux.
                </p>
                <PlatformSelector {...platformSelectorProps} />
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { singlePage } = state.pages;

  return {
    singlePage
  };
};

export default connect(mapStateToProps)(Biond);



// WEBPACK FOOTER //
// ./src/views/Biond.jsx